module.exports = __webpack_public_path__ + "static/media/color-brain.8302caf7.svg";